import React from "react";
import "../styles/pageHero.css";

function PageHero({ eyebrow, title, subtitle, actions }) {
  return (
    <section className="page-hero">
      <div className="container page-hero-inner">
        {eyebrow && (
          <span className="eyebrow">
            <span className="eyebrow-dot" aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
        {actions && <div className="page-hero-actions">{actions}</div>}
      </div>
    </section>
  );
}

export default PageHero;
